import React, { createContext, useContext, useState, useCallback } from 'react';

const FilterContext = createContext();
export const useFilters = () => useContext(FilterContext);

/* Helper: return YYYY-MM-DD string for today + `days` offset */
function offsetDate(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
}

export const FilterProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    dateSlice: 'all', // today, 1w, 1m, 3m, 6m, all, custom
    dateFrom: '',
    dateTo: '',
    market: '',
    analysisType: '',
    status: '',
    product: '',
    test: '',
  });

  const setFilter = useCallback((key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  }, []);

  const setDateSlice = useCallback((slice) => {
    const today = new Date().toISOString().split('T')[0];
    let dateFrom = '';
    let dateTo = today;

    switch (slice) {
      case 'today':
        dateFrom = today;
        break;
      case '1w':
        dateFrom = offsetDate(-7);
        break;
      case '1m':
        dateFrom = offsetDate(-30);
        break;
      case '3m':
        dateFrom = offsetDate(-90);
        break;
      case '6m':
        dateFrom = offsetDate(-180);
        break;
      case 'all':
        dateFrom = '';
        dateTo = '';
        break;
      case 'custom':
        setFilters(prev => ({ ...prev, dateSlice: 'custom' }));
        return;
      default:
        break;
    }

    setFilters(prev => ({ ...prev, dateSlice: slice, dateFrom, dateTo }));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters({
      dateSlice: 'all',
      dateFrom: '',
      dateTo: '',
      market: '',
      analysisType: '',
      status: '',
      product: '',
      test: '',
    });
  }, []);

  // Build query-string object (excludes empty values)
  const buildQueryParams = useCallback(() => {
    const params = {};
    if (filters.dateFrom) params.dateFrom = filters.dateFrom;
    if (filters.dateTo) params.dateTo = filters.dateTo;
    if (filters.market) params.market = filters.market;
    if (filters.analysisType) params.analysisType = filters.analysisType;
    if (filters.status) params.status = filters.status;
    if (filters.product) params.product = filters.product;
    if (filters.test) params.test = filters.test;
    return params;
  }, [filters]);

  return (
    <FilterContext.Provider value={{ filters, setFilter, setDateSlice, clearFilters, buildQueryParams }}>
      {children}
    </FilterContext.Provider>
  );
};
